import HorizontalLayout from '../../../components/HorizontalLayout';
import DataBreachIncident from '../pages/thirdparty/data-breach-incident';
import DSRRequest from '../pages/thirdparty/dsr';
import ReportDetails from '../pages/report-details';
import MyReports from '../pages/thirdparty/my-reports';
import UserManual from '../pages/UserManual';

const dataProtectionRoutes = [
	{
		path: '/third-party/data-protection/user_manual',
		component: UserManual,
		layout: HorizontalLayout,
		type: 'third-party',
		modules: ["gd"]
	},
	{
		path: '/third-party/data-protection/data-subject-request/details/:id',
		component: ReportDetails,
		layout: HorizontalLayout,
		type: 'third-party',
		modules: ["gd"],
        isAuthProtected: true
	},
	{
		path: '/third-party/data-protection/incident-register/details/:id',
		component: ReportDetails,
		layout: HorizontalLayout,
		type: 'third-party',
		modules: ["gd"],
        isAuthProtected: true
	},
	{
		path: '/third-party/data-protection/reports',
		component: MyReports,
		layout: HorizontalLayout,
		type: 'third-party',
		modules: ["gd"],
		title: 'List Reports | SIP',
        isAuthProtected: true
	},
    {
		path: '/third-party/data-protection/data-breach-incident',
		component: DataBreachIncident,
		layout: HorizontalLayout,
		type: 'third-party',
		modules: ["gd"],
		title: 'Data Breach Incident Request | SIP',
	},
	{
		path			:	'/third-party/data-protection/data-subject-request',
		component		:	DSRRequest,
		layout			:	HorizontalLayout,
		type			:	'third-party',
		modules         :   ["gd"],
		title			:	'DSR Request | SIP',
	}
];

export default dataProtectionRoutes;
